import { render } from "./DraftChange.vue?vue&type=template&id=55075b80&scoped=true"
import script from "./DraftChange.vue?vue&type=script&lang=js"
export * from "./DraftChange.vue?vue&type=script&lang=js"

import "./DraftChange.vue?vue&type=style&index=0&id=55075b80&lang=css"
import "./DraftChange.vue?vue&type=style&index=1&id=55075b80&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55075b80"]])

export default __exports__